/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
/* eslint-disable class-methods-use-this */
import { Controller } from "@hotwired/stimulus";

const MOBILE_LIMIT_SIZE = 768;
const ACTIVE_CLASSES = ["border-secondary-500", "bg-secondary-50"];
const INACTIVE_CLASSES = ["border-neutral-300", "bg-white"];

export default class extends Controller {
  static targets = ["option"];

  onWindowChange(e) {
    const isMobile = (e.innerWidth || e.target.innerWidth) < MOBILE_LIMIT_SIZE;

    if (isMobile) {
      // Disable portlet active classes on Mobile
      this.optionTargets.forEach((target) => {
        target.classList.remove(...ACTIVE_CLASSES);
        target.classList.add(...INACTIVE_CLASSES);
      });
    } else if (this.isMobile && !isMobile) {
      // Re-enable portlet active classes on Desktop
    }

    this.isMobile = isMobile;
  }

  onClickPortlet(e) {
    if (this.isMobile) return;

    this.changeOption(e);
  }

  changeOption(e) {
    this.optionTargets.forEach((item) => {
      item.classList.remove(...ACTIVE_CLASSES);
      item.classList.add(...INACTIVE_CLASSES);
    });

    e.currentTarget.classList.remove(...INACTIVE_CLASSES);
    e.currentTarget.classList.add(...ACTIVE_CLASSES);
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === identifier;
    });
  }
}
